/**
  Intro:

  Import this module to receive a wrapper singleton instance of vikilitics
  For default sendEvent params sent, please see `AppContext.__proto__.getParams`

  Config of the collector uri is abstracted out when using this module - its not
  a good practice to bundle state with code or make unclear how intialisation is
  done. In this case intialisation is not made clear when using to make using
  this module easier. But you should know that its leveraging
  `window.app.vikilitics` to do so

  Usage:  ----------------------------------------------------------------------

    import VikiliticsWrapper from 'scripts/lib/Vikilitics/VikiliticsWrapper'

    VikiliticsWrapper.sendEvent('my-event-name', {...allAdditionalParams})

  ------------------------------------------------------------------------------

  Additional_Development:

  Feel free to add any other events that implements on top of sendEvent. You can
  use `sendPvEvent` below as an implementation template
**/

import Vikilitics from 'vikilitics'
import AppContext from 'scripts/lib/Vikilitics/AppContext'
import { isWindowAvailable, isDocumentAvailable } from 'scripts/helpers/Utils'

const EVENT_PAGEVIEW_KEY = 'pv'

class VikiliticsWrapper {
  static _singleton = null

  constructor() {
    if (isWindowAvailable()) {
      const vklParams = (window && window.app && window.app.vikilitics) || {}
      // Singleton for SPA usage - repeat intialisation is a grandiose no-no
      if (VikiliticsWrapper._singleton === null) {
        VikiliticsWrapper._singleton = new Vikilitics(new AppContext(), vklParams)
        VikiliticsWrapper._singleton.setBasicParamsFunction(this.defaultEventParams.bind(this))
      }
      // Proxy to vikilitics sendEvent method
      if (vklParams.ns && vklParams.host) {
        this.sendEvent = VikiliticsWrapper._singleton.sendEvent.bind(VikiliticsWrapper._singleton)
      }
    }
    this.lastPageParams = {}
  }

  // Default Stub
  sendEvent() {}

  defaultEventParams(app) {
    return app.getParams()
  }

  sendPvEvent(pageId, params) {
    const lastPageParams = {
      prev_page_id: this.lastPageParams.prevPageId,
      prev_url: this.lastPageParams.prevPageUrl
    }
    // If last page is not found, use referring page instead
    if (typeof (lastPageParams.prev_url) === 'undefined' && isDocumentAvailable() && document.referrer) {
      lastPageParams.prev_url = document.referrer
      lastPageParams.last_referrer = 'true'
    }

    this.sendEvent(EVENT_PAGEVIEW_KEY, Object.assign({
      page_id: pageId
    }, lastPageParams, params))

    // Initialise current page as last page as state for next page's last page
    if (isWindowAvailable()) {
      this.lastPageParams = {
        prevPageId: pageId,
        prevPageUrl: window.location.href
      }
    }
  }
}
const vikiliticsWrapper = new VikiliticsWrapper()

export default vikiliticsWrapper



// WEBPACK FOOTER //
// ./assets/js/lib/Vikilitics/VikiliticsWrapper.js